import React from "react"
import { FaIcon } from "../../ui"

const Icon = ({ value }) => value && <FaIcon icon={value} size={24} />

export default Icon
